__turbopack_context__.v({
  "articleHead": "video-module__Gcxhla__articleHead",
  "boldText": "video-module__Gcxhla__boldText",
  "contactWrapper": "video-module__Gcxhla__contactWrapper",
  "description": "video-module__Gcxhla__description",
  "divider": "video-module__Gcxhla__divider",
  "iframe": "video-module__Gcxhla__iframe",
  "image": "video-module__Gcxhla__image",
  "largeText": "video-module__Gcxhla__largeText",
  "leftPanel": "video-module__Gcxhla__leftPanel",
  "line": "video-module__Gcxhla__line",
  "mediaWrapper": "video-module__Gcxhla__mediaWrapper",
  "moduleWrapper": "video-module__Gcxhla__moduleWrapper",
  "normalText": "video-module__Gcxhla__normalText",
  "outerWrapper": "video-module__Gcxhla__outerWrapper",
  "readingLine": "video-module__Gcxhla__readingLine",
  "rightPanel": "video-module__Gcxhla__rightPanel",
  "root": "video-module__Gcxhla__root",
  "socialWrapper": "video-module__Gcxhla__socialWrapper",
  "taxonomy": "video-module__Gcxhla__taxonomy",
  "taxonomyItem": "video-module__Gcxhla__taxonomyItem",
  "taxonomyList": "video-module__Gcxhla__taxonomyList",
  "taxonomyWrapper": "video-module__Gcxhla__taxonomyWrapper",
  "virtualTour": "video-module__Gcxhla__virtualTour",
  "youtubeWrapper": "video-module__Gcxhla__youtubeWrapper",
});
